// AgentVerse/client/ui/ProjectTasks.js
import { ComponentBase } from "../core/ComponentBase.js";

export class ProjectTasks extends ComponentBase {
    constructor(config) {
        super(config);
        this.taskManager = null;
        this.currentProject = null;
        this.myContactId = null; // We still need this

        this._boundHandleProjectSelected = this.handleProjectSelected.bind(this);
    }

    async initialize() {
        await super.initialize();
        this.appClient.events.local.on('projectSelected', this._boundHandleProjectSelected);
    }

    async initAfterLogin() {
        try {
            // This is a one-time fetch for the user's own global contact ID
            const userContact = await this.appClient.rpcClient.call('MessagingContactsRpc.findByAppUserId', {
                appUserId: this.appClient.getSharedData('userId')
            }, {}); 
            if (userContact) {
                this.myContactId = userContact.contactId;
                this.appClient.setSharedData('myMessagingContactId', this.myContactId); // Cache for other components
            } else {
                this.log.warn("Could not resolve current user's messaging contact ID. Task manager may be affected.");
            }
        } catch (error) {
            this.log.error("Failed to fetch user's messaging contact:", error);
        }

        // Trigger the initial setup based on the currently selected project (if any)
        const selectedProject = this.appClient.getSharedData('selectedProject');
        await this.handleProjectSelected({ projectData: selectedProject });
    }

    async handleProjectSelected({ projectData }) {
        const newProjectId = projectData ? projectData._id : null;

        // --- THE DEFINITIVE FIX ---
        // 1. If project hasn't changed, do nothing.
        if (this.currentProject?._id === newProjectId) {
            return;
        }

        // 2. Update the current project state.
        this.currentProject = projectData;
        this.log.info(`ProjectTasks: Project changed to ${this.currentProject?.name || 'None'}. Rebuilding TaskManager.`);
        
        // 3. If a TaskManager instance already exists, DESTROY IT COMPLETELY.
        if (this.taskManager) {
            this.taskManager.destroy();
            this.taskManager = null;
        }

        // 4. If a new project is selected, create a brand new TaskWorkspaceManager instance.
        if (this.currentProject) {
            this.taskManager = await this.createManagedComponent('TaskWorkspaceManager', null, {
                instanceId: 'project-tasks-manager',
                showTaskSelector: true,
                // Pass the context for the new instance
                contextId: this.currentProject._id,
                contextType: 'project',
                ownerId: this.myContactId // Pass the user's contact ID
            });
        }
        
        // --- END FIX ---
        
        // 5. Re-render this component's container. This will either show the new
        //    TaskManager or the "select project" placeholder.
        if (this.container) {
            await this.render();
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'project-tasks-wrapper h-100';
        }
        this.container.innerHTML = '';

        if (this.currentProject && this.taskManager) {
            // Append the new, clean TaskManager instance's container
            this.container.appendChild(await this.taskManager.render());
        } else {
            // Show the placeholder if no project is selected
            const placeholder = document.createElement('div');
            placeholder.className = 'alert alert-info text-center m-3';
            placeholder.setAttribute('role', 'alert');
            placeholder.innerHTML = `<i class="bi bi-info-circle-fill me-2"></i> ${this.t('Please select a project to manage its tasks.')}`;
            this.container.appendChild(placeholder);
            this.appClient.tx.applyTranslations(placeholder);
        }

        return this.container;
    }

    destroy() {
        this.appClient.events.local.off('projectSelected', this._boundHandleProjectSelected);
        this.taskManager?.destroy(); // Ensure it's destroyed when ProjectTasks is destroyed
        this.taskManager = null;
        super.destroy();
    }
}